// extracted by mini-css-extract-plugin
export default {"lds-spinner":"style_lds-spinner__FZArW","div-after":"style_div-after__47TXn"};